const ADD_CARD = 'addCard'
const RUN_BALANCE = 'runBalance'
const TRANSFER_BALANCE = 'transferBalance'

export const INTENTS = {
  ADD_CARD,
  RUN_BALANCE,
  TRANSFER_BALANCE,
} as const
